import API_URLS from '@Constants/apiUrls.constants';
import { DncAdd, DncEdit, DncList } from '@Models/dnc.models';

import { baseApi } from './baseApi.service';

/**
 * GLOBAL - Handle Normal operations
 * GLOBAL_DNC - Handle Bulk operations
 */
const {
  DNC: { PHONE, PHONES, RESTORE, GLOBAL, GLOBAL_DNC, VIEW },
} = API_URLS;

export const globalDncApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['DNC'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getGlobalDnc: builder.query<DncList, string>({
        query: (dncId) => ({
          url: `${GLOBAL}/${PHONES}/${VIEW}`,
          method: 'POST',
          body: {
            filters: [
              {
                operationType: 'EQUALS',
                propertyName: 'ID',
                dateRangeValue: null,
                value: dncId,
              },
            ],
          },
        }),
        providesTags: ['DNC'],
      }),

      getGlobalDncList: builder.query<DncList, DncList>({
        query: (body) => ({
          url: `${GLOBAL}/${PHONES}/${VIEW}`,
          method: 'POST',
          body,
        }),
        providesTags: ['DNC'],
      }),

      restoreGlobalDncRow: builder.mutation<DncList, string>({
        query: (id) => ({
          url: `${GLOBAL}/${PHONE}/${RESTORE}/${id}`,
          method: 'PUT',
          body: id,
        }),
        invalidatesTags: ['DNC'],
      }),

      deleteGlobalDncRows: builder.mutation<DncList, readonly string[]>({
        query: (ids) => ({
          url: `${GLOBAL}/${PHONES}/${ids.join('%2C')}`,
          method: 'DELETE',
          body: ids.join(','),
        }),
        invalidatesTags: ['DNC'],
      }),

      editGlobalDncRow: builder.mutation<void, DncEdit>({
        query: ({ id, phone, reason, comments }) => ({
          url: `${GLOBAL}/${PHONE}/${id}`,
          method: 'PUT',
          body: {
            phone,
            reason,
            comments,
          },
        }),
        invalidatesTags: ['DNC'],
      }),

      addGlobalDncRow: builder.mutation<void, DncAdd>({
        query: ({ phone, reason, comments }) => ({
          url: `${GLOBAL}/${PHONE}`,
          method: 'POST',
          body: {
            phone,
            reason,
            comments,
          },
        }),
        invalidatesTags: ['DNC'],
      }),

      deleteBulkGlobalDncRows: builder.mutation<DncList, DncList>({
        query: (body) => ({
          url: `${GLOBAL_DNC}/${PHONES}`,
          method: 'DELETE',
          body,
        }),
        invalidatesTags: ['DNC'],
      }),
    }),
  });

export const {
  useGetGlobalDncQuery,
  useGetGlobalDncListQuery,
  useRestoreGlobalDncRowMutation,
  useDeleteGlobalDncRowsMutation,
  useEditGlobalDncRowMutation,
  useAddGlobalDncRowMutation,
  useDeleteBulkGlobalDncRowsMutation,
} = globalDncApi;
